import { useAuthStore } from '~/modules/auth/stores/auth.store';

export default defineNuxtRouteMiddleware(async (to, from) => {
  const {
    meta: { requiresAuth = true },
    name,
  } = to;

  const authStore = useAuthStore();
  const userLoggedIn = authStore.isLoggedIn;

  // Условия прервать навигацию и изменить роут назначения
  if (name === 'auth-not-authorized' && userLoggedIn) {
    return from.path === '/auth/not-authorized' ? '/' : abortNavigation();
  }

  // Условия продолжения навигации
  if (name === 'auth-not-authorized' && !userLoggedIn) {
    return;
  } else if (!requiresAuth || userLoggedIn) {
    return;
  }
  // роут защищен и нет авторизации
  return '/auth/not-authorized';
});

declare module '#app' {
  interface PageMeta {
    /**
     * Установлена по умолчанию как true
     */
    requiresAuth?: boolean;
  }
}

declare module 'vue-router' {
  interface RouteMeta {
    /**
     * Установлена по умолчанию как true
     */
    requiresAuth?: boolean;
  }
}
